import React from 'react';
import PropTypes from 'prop-types';
// import ReactPlyr from 'react-plyr';
import AudioPlayerComp from 'react-h5-audio-player';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import 'react-h5-audio-player/lib/styles.css';
import Button from '../../atoms/Button';
import { useTranslation } from '../../../config/i18n';

const audioFormats = ['mp3', 'wav', 'ogg'];

const AudioPlayer = ({ title, autoPlay, src, ...props }) => {
const {t} = useTranslation('common')
  const format = src.substring(src.length - 3);
  // console.log('audioFormats.includes(format.toLowerCase)',audioFormats.includes(format.toLowerCase()))
  if (audioFormats.includes(format.toLowerCase())) {
    return <AudioPlayerComp autoPlay={autoPlay} src={src} {...props} />;
  }

  return (
    <Button startIcon={<CloudDownloadIcon />} variant="outlined" href={src}>
      {t('download')}
    </Button>
  );
};

AudioPlayer.propTypes = {
  title: PropTypes.string,
  src: PropTypes.string.isRequired,
  autoPlay: PropTypes.bool,
};
AudioPlayer.defaultProps = {
  title: undefined,
  autoPlay: false,
};

export default AudioPlayer;

// Check this later https://cookpete.com/react-player/
